import { render, staticRenderFns } from "./VWrapper.vue?vue&type=template&id=325daff7&scoped=true&"
import script from "./VWrapper.vue?vue&type=script&lang=js&"
export * from "./VWrapper.vue?vue&type=script&lang=js&"
import style0 from "./VWrapper.vue?vue&type=style&index=0&id=325daff7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325daff7",
  null
  
)

export default component.exports